import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace GeneralDockDiving {
  export const form: IEventRegisterRow[] = [{
    inputs: []
  }];
}
